/**
 * Career API Service
 * Handles fetching career/job listing data from the CMS
 */

import { api } from "../core/api.client";
import { ApiClientResponse } from "../core/api.types";
import { CareerItem, CareerFilters } from "../../types/careerType";

export class CareerApi {
  private readonly endpoint = "landing-career";

  /**
   * Get all career listings
   */
  async getCareers(
    filters?: CareerFilters
  ): Promise<ApiClientResponse<CareerItem[]>> {
    const params: Record<string, any> = {};

    if (filters) {
      if (filters.location) params.location = filters.location;
      if (filters.employmentType)
        params.employmentType = filters.employmentType;
      if (filters.isActive !== undefined) params.isActive = filters.isActive;
      if (filters.search) params.search = filters.search;
    }

    return api.get<CareerItem[]>(this.endpoint, { params });
  }

  /**
   * Get career by ID
   */
  async getCareerById(id: string): Promise<ApiClientResponse<CareerItem>> {
    return api.get<CareerItem>(`${this.endpoint}/${id}`);
  }

  /**
   * Get active career listings only
   */
  async getActiveCareers(): Promise<ApiClientResponse<CareerItem[]>> {
    return this.getCareers({ isActive: true });
  }
}

// Export singleton instance
export const careerApi = new CareerApi();

// Export convenience methods
export const careers = {
  getAll: (filters?: CareerFilters) => careerApi.getCareers(filters),
  getById: (id: string) => careerApi.getCareerById(id),
  getActive: () => careerApi.getActiveCareers(),
};
